import React, { useState } from 'react';
import { SAPLayout } from '@/layouts/SAPLayout/SAPLayout';
import { mockSapSimulatorService } from '@/services/mock/MockSapSimulatorService';
import { SapSimulationScenario } from '@/types/domain/sap-simulator';
import { SapFailureInjectionPanel } from '@/components/sap/SapFailureInjectionPanel';
import { Cpu } from 'lucide-react';

export const SapSimulationControlPage: React.FC = () => {
  const [config, setConfig] = useState(mockSapSimulatorService.getSimulationConfig());

  const handleScenarioChange = (scenario: SapSimulationScenario) => {
    mockSapSimulatorService.setSimulationScenario(scenario);
    setConfig(mockSapSimulatorService.getSimulationConfig());
  };

  return (
    <SAPLayout>
      <div className="space-y-6 font-heading">
        <div>
          <h2 className="text-xl font-extrabold text-foreground flex items-center gap-2">
            <Cpu className="h-5 w-5 text-primary" /> Simulation Control & Failure Injection Engine
          </h2>
          <p className="text-xs text-foreground-secondary font-medium">
            Configure active response scenarios to test ProcureAI exception handling, timeout delays, and idempotency protection.
          </p>
        </div>

        <SapFailureInjectionPanel
          activeScenario={config.activeScenario}
          onScenarioChange={handleScenarioChange}
        />
      </div>
    </SAPLayout>
  );
};
